import React from 'react';

import logoWhiteImage from '../../../assets/img/logo_white.png';

import { VERSION_DISPLAY } from '../../global/config';
import { Box } from '../Box/Box';
import { CircularProgress } from '../CircularProgress/CircularProgress';
import { Typography } from '../Typography/Typography';

export const SplashSpinner = (): React.ReactElement => {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.palette.primary.main,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%'
      })}>
      <Box sx={{ width: '480px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <img src={logoWhiteImage} alt='Logo' style={{ maxHeight: '96px', width: '164px', display: 'block' }} />
        <Typography color='primaryInverted' text={VERSION_DISPLAY} />
        <CircularProgress color='primaryInverted' sx={{ marginY: 3 }} />
        <Typography color='primaryInverted' variant='body1Bold' text='Initializing' />
        <Typography color='primaryInverted' variant='body1Bold' text='AWESOMENESS' />
      </Box>
    </Box>
  );
};
